import './discount.css'
import {formatDisplayPrice} from "../../../res/dataServices/pricing";
import {getDiscountName, getDiscountValue, getSummaryName, mapDiscountToList} from "../calculator/discountDetail";

const Saved = ({ summary }) => {
    if(summary.totalSaved <= 0)
        return;

    const saving = formatDisplayPrice(summary.totalSaved);
    const applied = mapDiscountToList(summary.appliedSavings);

    return (
        <div style={{marginBottom: 18}}>
            <div className="discount-rule-container discount-rule-summary" style={{marginBottom: 8}}>
                <p className="discount-header">You have saved</p>
                <p className="discount-rule-price">{saving}</p>
            </div>
            {applied.map(a =>
                <div key={a.discountType} className="discount-rule-container applied-discount" style={{marginBottom: 6}}>
                    <p style={{marginLeft: 12}}>{getSummaryName(a.discountType)}</p>
                    <p className="discount-rule-price">{formatDisplayPrice(a.items)}</p>
                </div>
            )}
        </div>
    )
}

const Missed = ({ summary }) => {
    if(summary.maxSaving <= summary.totalSaved)
        return;

    const hasSomeSavings = summary.totalSaved > 0;
    const message = hasSomeSavings ? 'You could save a further' : 'You could save';
    const saving = formatDisplayPrice(summary.maxSaving);
    const unmet = mapDiscountToList(summary.furtherSavings);


    return (
        <div>
            <div className="discount-rule-container discount-rule-summary">
                <p className="discount-header">{message}</p>
                <p className="discount-rule-price">{saving}</p>
            </div>

            {unmet.map(a =>
                <div key={a.discountType}>
                    <p style={{marginLeft: 12}}>{getDiscountName(a.discountType)}</p>
                    {a.items.map(i =>
                        <div key={i.seqNo} className="discount-rule-container applied-discount" style={{marginBottom: 6}}>
                            <p style={{marginLeft: 24}}>{getDiscountValue(i)}</p>
                            <p className="discount-rule-price">{formatDisplayPrice(i.discount)}</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

const DiscountCartSummary = ({ summary }) => {

    return (
        <div className="discount-rule-display cart-discount-summary">
            <Saved summary={summary} />
            <Missed summary={summary} />
        </div>
    )
}

export default DiscountCartSummary;